import type { MouseEventHandler } from 'react';
import Button, { ButtonContainer, LoadingButton } from '../../form/Button';

interface ModalFooterProps {
    onClose: MouseEventHandler<HTMLButtonElement>;
    onSave?: MouseEventHandler<HTMLButtonElement>;
    onDelete?: MouseEventHandler<HTMLButtonElement>;
    formId?: string;
    saveLabel?: string;
    saveButtonType?: 'button' | 'submit';
    saveDisabled?: boolean;
    isLoading?: boolean;
}

export function ModalFooter({
    onClose,
    onSave,
    onDelete,
    formId,
    saveLabel,
    saveButtonType = 'button',
    saveDisabled = false,
    isLoading,
}: ModalFooterProps): JSX.Element {
    return (
        <div className="mt-6 flex justify-between px-6">
            <div>
                {onDelete && (
                    <Button variant="destructive" onClick={onDelete} type="button">
                        {gettext('DELETE')}
                    </Button>
                )}
            </div>
            <ButtonContainer>
                <Button variant="neutral" onClick={onClose} disabled={isLoading} type="button">
                    {gettext('CANCEL')}
                </Button>
                <LoadingButton
                    variant="action"
                    onClick={onSave}
                    disabled={isLoading || saveDisabled}
                    type={saveButtonType}
                    form={formId}
                    label={saveLabel}
                    isLoading={isLoading}
                />
            </ButtonContainer>
        </div>
    );
}
